import { authApi } from '@/shared/api/auth';
import { setInactivityTimeoutCallback } from '@/shared/api/index';
import { useCallback, useEffect, useRef } from 'react';

const TIMEOUT_DURATION = 30 * 60 * 1000;

export const useInactivityTimeout = () => {
  const timeoutRef = useRef<number | null>(null);
  const isActiveRef = useRef(true);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      if (isActiveRef.current) {
        authApi.logoutInactivity();
      }
    }, TIMEOUT_DURATION);
  }, []);

  const handleUserActivity = useCallback(() => {
    resetTimer();
  }, [resetTimer]);

  useEffect(() => {
    const events = ['mousedown', 'keypress', 'scroll', 'touchstart', 'click'];

    events.forEach((event) => {
      document.addEventListener(event, handleUserActivity, true);
    });

    setInactivityTimeoutCallback(resetTimer);
    resetTimer();

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, handleUserActivity, true);
      });
      setInactivityTimeoutCallback(null);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      isActiveRef.current = false;
    };
  }, [handleUserActivity, resetTimer]);

  return { resetTimer };
};
